import { useState } from "react";
import { X, Key, Download } from "lucide-react";
import api from "../../services/api";
import ImportInfo from "./ImportInfo";
import ImportResult from "./ImportResult";

export function ImportModal({ onClose, onSave }) {
  var fileState = useState(null);
  var passwordState = useState("Methos@2026");
  var loadingState = useState(false);
  var downloadingState = useState(false);
  var resultState = useState(null);
  var errorState = useState(null);

  async function handleDownloadTemplate() {
    downloadingState[1](true);
    try {
      var baseUrl = process.env.REACT_APP_BACKEND_URL || "";
      window.open(baseUrl + "/api/clients/template", "_blank");
    } catch(err) { errorState[1]("Erro ao baixar modelo."); }
    finally { downloadingState[1](false); }
  }

  async function handleImport() {
    if (!fileState[0]) return;
    loadingState[1](true); errorState[1](null); resultState[1](null);
    try {
      var formData = new FormData();
      formData.append("file", fileState[0]);
      formData.append("default_password", passwordState[0]);
      var res = await api.post("/clients/import", formData, { headers: { "Content-Type": "multipart/form-data" } });
      resultState[1](res.data);
    } catch(err) { errorState[1](err.response?.data?.detail || "Erro na importacao"); }
    finally { loadingState[1](false); }
  }

  return (
    <div>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-lg" data-testid="import-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">Importar Clientes</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          <div className="p-5 space-y-4">
            <ImportInfo />
            <button onClick={handleDownloadTemplate} disabled={downloadingState[0]}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#0A2F3D] text-white rounded-xl text-sm font-medium hover:bg-[#0A2F3D]/90 transition-colors"
              data-testid="import-download-template">
              <Download className="w-4 h-4" />
              {downloadingState[0] ? "Baixando..." : "Baixar Modelo Excel"}
            </button>
            <div className="border-t border-gray-100 pt-4">
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Arquivo Excel (.xlsx)</label>
              <input type="file" accept=".xlsx,.xls"
                onChange={function(e) { fileState[1](e.target.files[0] || null); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                data-testid="import-file-input" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Senha padrao para novos clientes</label>
              <div className="flex items-center gap-2">
                <Key className="w-4 h-4 text-gray-400" />
                <input type="text" value={passwordState[0]} onChange={function(e) { passwordState[1](e.target.value); }}
                  className="flex-1 px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="Senha padrao" data-testid="import-default-password" />
              </div>
              <p className="text-xs text-gray-400 mt-1">Clientes serao solicitados a alterar a senha no primeiro acesso</p>
            </div>
            {errorState[0] && <div className="px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
            {resultState[0] && <ImportResult result={resultState[0]} />}
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={resultState[0] ? function() { onSave(); } : onClose}
                className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">
                {resultState[0] ? "Fechar" : "Cancelar"}
              </button>
              {!resultState[0] && (
                <button onClick={handleImport} disabled={loadingState[0] || !fileState[0]}
                  className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50"
                  data-testid="import-submit">
                  {loadingState[0] ? "Importando..." : "Importar"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
